import manifest from './manifest.json';

export function getManifest(): any
{
    // Find the highest resolution of each version of UI assets available
    const png = manifest.default.image.ui.standard.high;
    
    // Force app to always load highest version of UI, regardless the quality version set
    manifest.default.image.ui.standard.low = png;
    manifest.default.image.ui.standard.default = png;
    manifest.default.image.ui.standard.high = png;
    
    if(manifest.default.image.ui.webp){
        const webp = manifest.default.image.ui.webp.high;
        manifest.default.image.ui.webp.low = webp;
        manifest.default.image.ui.webp.default = webp;
        manifest.default.image.ui.webp.high = webp;
    }
    
    return manifest;
}
